/* eslint-disable no-unused-vars */
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { English } from "../../Constant";
import { LI, UL, H6 } from "../../AbstractElements";
import { LanguageSquareIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "react-bootstrap";
// import {
//   Dropdown,
//   DropdownItem,
//   DropdownMenu,
//   DropdownToggle,
// } from "reactstrap";
// import { Link } from "react-router-dom";

const Language = () => {
  const { i18n } = useTranslation();
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selected, setSelected] = useState(i18n.language);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelected(lng);
  };

  // const toggle = () => setDropdownOpen((prevState) => !prevState);

  return (
    <Fragment>

      <H6 attrH6={{ className: "txt-dark mb-0 mt-1" }}>
        <Button variant="secondary" size="xs" className="btn-outline btn-icon">
          <HugeiconsIcon icon={LanguageSquareIcon} />
        </Button>
      </H6>
      <div className={`language-dropdown onhover-show-div`}>
        <UL attrUL={{ className: `simple-list p-3` }}>
          <LI
            attrLI={{
              onClick: () => changeLanguage("en"),
              className: selected === "en" ? "active" : undefined,
            }}
          >
            <a href="#javascript" data-lng="en">
              <i className="flag-icon flag-icon-is"></i> {English}
            </a>
          </LI>
          <LI
            attrLI={{
              onClick: () => changeLanguage("ae"),
              className: selected === "ae" ? "active" : undefined,
            }}
          >
            <a href="#javascript" data-lng="ae">
              <i className="flag-icon flag-icon-sa"></i> {"العربية"}
            </a>
          </LI>
        </UL>
      </div>
    </Fragment>
  );
};
export default Language;
